// this is an autogenerated file from App/Account/Content/Settings/Content/Charges/Content/Content/Charge/ActionsAction/Edit/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Charges_Content_Content_Charge_ActionsAction_Edit_Content(
  $id: numeric!
  $charge: vaxiom_misc_fee_charge_templates_set_input!
  $procedures: [vaxiom_procedure_misc_fee_charge_templates_insert_input!]!
) {
  update_vaxiom_misc_fee_charge_templates_by_pk(
    pk_columns: { id: $id }
    _set: $charge
  ) {
    id
    name
    price
    insurance_code_id
    affecting_production_report
    is_included_in_insurance_claim
    requires_tooth_details
    sys_created
    sys_last_modified
    insurance_code {
      id
      code
    }
  }
  delete_vaxiom_procedure_misc_fee_charge_templates(
    where: { misc_fee_charge_template_id: { _eq: $id } }
  ) {
    affected_rows
  }
  insert_vaxiom_procedure_misc_fee_charge_templates(objects: $procedures) {
    affected_rows
  }
}

`